import SingleActionButtonPanel from './SingleActionButtonPanel';
export default SingleActionButtonPanel;